import { render, staticRenderFns } from "./RemainderOfEstateBase.vue?vue&type=template&id=7af71ee1"
import script from "./RemainderOfEstateBase.vue?vue&type=script&lang=js"
export * from "./RemainderOfEstateBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports